<kendo-dialog [title]="isEditMode ? 'Edit Acknowledgment' : 'Acknowledge Gap Finding'" [width]="550" (close)="onCancel()">
  <div class="py-2">
    <!-- Finding context -->
    <div class="mb-3 p-3 bg-light rounded-2">
      <div class="fw-medium small">{{ finding().title }}</div>
      <div class="text-muted small mt-1">{{ finding().normalized_text }}</div>
    </div>

    <!-- Note -->
    <div class="mb-3">
      <label class="form-label small fw-medium">Note / Justification <span class="text-danger">*</span></label>
      <textarea
        class="form-control form-control-sm"
        rows="3"
        placeholder="Describe why this gap is being accepted..."
        [ngModel]="note()"
        (ngModelChange)="note.set($event)"
      ></textarea>
    </div>

    <!-- Compensating control toggle -->
    <div class="form-check mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="compensatingControl"
        [ngModel]="isCompensatingControl()"
        (ngModelChange)="isCompensatingControl.set($event)"
      />
      <label class="form-check-label small" for="compensatingControl">
        This has a compensating control in place
      </label>
    </div>

    <!-- Compensating control description -->
    @if (isCompensatingControl()) {
      <div class="mb-3 ms-4">
        <label class="form-label small fw-medium">Compensating Control Description</label>
        <textarea
          class="form-control form-control-sm"
          rows="2"
          placeholder="Describe the compensating control..."
          [ngModel]="compensatingDescription()"
          (ngModelChange)="compensatingDescription.set($event)"
        ></textarea>
      </div>
    }
  </div>

  <kendo-dialog-actions>
    <button class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button
      class="btn btn-primary"
      [disabled]="!note().trim() || isSaving()"
      (click)="onSave()"
    >
      @if (isSaving()) {
        Saving...
      } @else if (isEditMode) {
        Update
      } @else {
        Acknowledge
      }
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
